import { useEffect } from 'react';
import { calc300 } from './calc300';
import { calc302 } from './calc302';
import { calc400 } from './calc400';
import { MockResponse } from './mock-response';
import { Processor } from './types';

const versionMap: Record<string, Processor> = {
  '3.0.0': calc300,
  '3.0.2': calc302,
  '4.0.1': calc400,
  '4.0.2': calc400, // We don't have a published package to actually call, it will fail
};

export function useCalcIntercept(urlVersion: string | undefined) {
  const version = urlVersion ?? '3.0.0';

  useEffect(() => {
    const originalFetch = window.fetch;
    window.fetch = async (input: Request | URL | string, init?: RequestInit) => {
      if (typeof input === 'string') {
        return originalFetch(input, init);
      }
      if (input instanceof URL) {
        return originalFetch(input.toString(), init);
      }
      const json = await input.json();
      const { url } = input;
      const calculator = url.split('/').pop();

      const processor = versionMap[version];

      if (!processor) {
        return new MockResponse(`Calculator version ${version} not found`, { status: 404 }, url);
      }

      if (!calculator) {
        return new MockResponse(`Calculator name not found in URL`, { status: 404 }, url);
      }

      const processorResponse = processor(calculator, json, url);

      return new MockResponse(
        JSON.stringify(processorResponse.body),
        { status: processorResponse.status, headers: { 'Content-Type': 'application/json' } },
        url,
      );
    };
  }, []);
}
